// @ts-nocheck
/* eslint-disable */
;
import { addMap } from "~/util/keymap";
import { store } from "~/state/store";

(function(){
	var Eggs = {
		init: function() {
			addMap("52,69,83,75,79,84,69,88,84,69,77", () => Eggs.text()); // českotextem
			addMap("67,69,83,75,79,84,69,88,84,69,77", () => Eggs.text()); // ceskotextem
			addMap("67,69,83,75,79,90,65,97,96,96", () => Eggs.zasto()); // ceskoza100 - numpad
			addMap("52,69,83,75,79,90,65,97,96,96", () => Eggs.zasto());// českoza100 - numpad
			addMap("67,69,83,75,79,90,65,49,48,48", () => Eggs.zasto());// ceskoza100 - nad pismeny
			addMap("52,69,83,75,79,90,65,49,48,48", () => Eggs.zasto());// českoza100 - nad pismeny
			addMap("67,69,83,75,79,90,65,83,84,79", () => Eggs.zasto());// ceskozasto
			addMap("52,69,83,75,79,90,65,83,84,79", () => Eggs.zasto());// českozasto
		},

		text: function() {
			const { mapset } = store.getState().map;

			if (mapset != "text") {
				Mapy.text();
				Mapy.getComponent("history").save();
			}
		},
		zasto: function() {
			const { mapset } = store.getState().map;

			if (mapset != "ceskoza100") {
				Mapy.zasto();
				Mapy.getComponent("history").save();
			}
		}
	}
	Eggs.init();
})();
